import React from "react";
import Filter from "./Filter";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import CardsSection from "./CardsSection";
import EarningList from "./EarningList";

const MyEarning = ({
  details,
  isLoading,
  isError,
  setDetails,
  getDetails,
  handleSearchChange,
  searchInput,
  dateRange,
  handleTimeSpan,
  handleDateRange,
  timeSpanInput,
  handleDateRangeSubmit,
  isShowDateFilter,
}) => {
  return (
    <MainComponentWrapper Loading={isLoading} errorInfo={isError}>
      <div className="event-my-earnings-body">
        <Filter
          isLoading={isLoading}
          isError={isError}
          setDetails={setDetails}
          getDetails={getDetails}
          handleSearchChange={handleSearchChange}
          searchInput={searchInput}
          dateRange={dateRange}
          handleTimeSpan={handleTimeSpan}
          handleDateRange={handleDateRange}
          timeSpanInput={timeSpanInput}
          handleDateRangeSubmit={handleDateRangeSubmit}
          isShowDateFilter={isShowDateFilter}
        />
        <CardsSection
          isError={isError}
          isLoading={isLoading}
          details={details}
        />
        <EarningList
          isError={isError}
          isLoading={isLoading}
          details={details?.topSalingEvents}
          getDetails={getDetails}
          setDetails={setDetails}
        />
      </div>
    </MainComponentWrapper>
  );
};

export default MyEarning;
